export const caseInsensitiveStringIncludes = (str: string, includes: string) =>
	str.toLocaleLowerCase().includes(includes.toLowerCase());

export default caseInsensitiveStringIncludes;
